import { render } from "./FormTextArea.vue?vue&type=template&id=63a9b44b&scoped=true"
import script from "./FormTextArea.vue?vue&type=script&lang=js"
export * from "./FormTextArea.vue?vue&type=script&lang=js"

import "./FormTextArea.vue?vue&type=style&index=0&id=63a9b44b&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-or-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a9b44b"]])

export default __exports__